/* ===========================================================================
   Party Yachts Miami — product (yacht) page behaviour

   Three jobs:
     1. Rate tier selection, which rewrites the WhatsApp message and the
        hidden variant id so the enquiry says which package the guest picked.
     2. Gallery lightbox. Around 17% of the photos are portrait, so a cropped
        thumbnail grid needs a full-size view to be usable.
     3. Event tracking, matching the names already used on the landing page.
   =========================================================================== */
(function () {
  if (window.__pymProductInit) return;
  window.__pymProductInit = true;

  window.dataLayer = window.dataLayer || [];

  function meta(event, params, standard) {
    if (typeof window.fbq !== 'function') return;
    try {
      window.fbq(standard ? 'track' : 'trackCustom', event, params || {});
    } catch (e) {}
  }

  var root = document.querySelector('[data-pym-pdp]');
  if (!root) return;

  var productTitle = root.getAttribute('data-pym-title') || '';

  /* ---------- Rate tiers ------------------------------------------------ */

  function applyTier(input) {
    if (!input) return;

    var tierLabel = input.getAttribute('data-tier-label') || '';
    var variantId = input.value;

    // Rewrite every message link so it names the chosen package. Covers
    // WhatsApp and SMS, which need different query spellings: wa.me takes
    // ?text=, the sms: scheme takes ?&body=. encodeURIComponent gives %20
    // for spaces, which both accept, unlike the "+" form encoding produces.
    // The old attribute name is still read so a cached copy of this file
    // keeps working against freshly rendered markup, and vice versa.
    var links = root.querySelectorAll('[data-pym-msg-template], [data-pym-wa-template]');
    Array.prototype.forEach.call(links, function (a) {
      var tpl = a.getAttribute('data-pym-msg-template') || a.getAttribute('data-pym-wa-template');
      if (!tpl) return;
      var msg = tpl.split('__TIER__').join(tierLabel).split('__YACHT__').join(productTitle);
      var base = a.getAttribute('href').split('?')[0];
      var sep = base.indexOf('sms:') === 0 ? '?&body=' : '?text=';
      a.setAttribute('href', base + sep + encodeURIComponent(msg));
    });

    var idField = root.querySelector('[data-pym-variant-id]');
    if (idField) idField.value = variantId;

    root.querySelectorAll('[data-pym-subject]').forEach(function (el) {
      el.value = productTitle + ' (' + tierLabel + ')';
    });
  }

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-pym-tier]');
    if (!input) return;
    applyTier(input);
    window.dataLayer.push({
      event: 'rate_tier_select',
      yacht_name: productTitle,
      tier: input.getAttribute('data-tier-label') || ''
    });
  });

  applyTier(root.querySelector('[data-pym-tier]:checked'));

  /* ---------- Lightbox -------------------------------------------------- */

  var lb = root.querySelector('[data-pym-lb]');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-pym-lb-open]'));
  var current = 0;
  var lastFocus = null;

  if (lb && items.length) {
    var img = lb.querySelector('[data-pym-lb-img]');
    var counter = lb.querySelector('[data-pym-lb-count]');

    function show(i) {
      current = (i + items.length) % items.length;
      var src = items[current].getAttribute('data-pym-lb-open');
      img.setAttribute('src', src);
      img.setAttribute('alt', items[current].getAttribute('data-pym-lb-alt') || '');
      if (counter) counter.textContent = current + 1 + ' of ' + items.length;
    }

    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = lb.querySelector('[data-pym-lb-close]');
      if (close) close.focus();
      window.dataLayer.push({ event: 'gallery_open', yacht_name: productTitle });
    }

    function close() {
      lb.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-pym-lb-open]');
      if (opener) {
        e.preventDefault();
        open(items.indexOf(opener));
        return;
      }
      if (e.target.closest('[data-pym-lb-close]')) return close();
      if (e.target.closest('[data-pym-lb-prev]')) return show(current - 1);
      if (e.target.closest('[data-pym-lb-next]')) return show(current + 1);
      // Clicking the backdrop, but not the photo itself, closes.
      if (e.target === lb) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  /* ---------- Show all photos ------------------------------------------ */

  var moreBtn = root.querySelector('[data-pym-gallery-more]');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      root.querySelectorAll('[data-pym-lb-open][hidden]').forEach(function (el) {
        el.hidden = false;
      });
      moreBtn.hidden = true;
      window.dataLayer.push({ event: 'gallery_expand', yacht_name: productTitle });
    });
  }

  /* ---------- Product level CTA tracking -------------------------------- */

  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-pym-track]');
    if (!el) return;

    var type = el.getAttribute('data-pym-track');
    var where = el.getAttribute('data-pym-location') || 'product';
    var tier = root.querySelector('[data-pym-tier]:checked');

    window.dataLayer.push({
      event: 'cta_click',
      cta_type: type,
      cta_location: where,
      yacht_name: productTitle,
      tier: tier ? tier.getAttribute('data-tier-label') : ''
    });

    if (type === 'call' || type === 'whatsapp' || type === 'sms') {
      meta('Contact', { method: type, placement: where, content_name: productTitle }, true);
    }
  });

  meta('ViewContent', { content_name: productTitle, content_type: 'yacht' }, true);
})();
